import { CapoPlugin } from "/codebuild/output/src3264125088/src/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];